import {PageProps} from '@/types';
import Search from "@/Atoms/Search/Search";
import Tile from "@/Molecules/Article/Tile";
import {Article} from "@/types/Article.d";
import Pagination from "@/Molecules/Pagination/Pagination";
import StickyContainer from "@/Molecules/StickyContainer/StickyContainer";
import {FormEvent, Fragment, useState} from "react";
import Commercial, {CommercialPageType, CommercialType} from "@/Atoms/Commercial";
import Page from "@/Pages/Page";
import TileList from "@/Molecules/Article/TileList";
import AdvertisementSection from "@/Organisms/Advertisements/AdvertisementSection";
import {relativeRoute} from "@/helpers/relativeRoute";
import { router } from '@inertiajs/react'

interface Pagination<T> {
  items: T[],
  page: number,
  pages: number
}

// export default function Articles({ baseUrl, articles }: PageProps<{ baseUrl: string, articles: PaginationType<Article>}>) {
export default function ArticleList(
  {
    baseUrl,
    category,
    search: initSearch,
    recent,
    funeral,
    mourning,
    inMemoriam,
    ...props
  }: PageProps<{
    baseUrl: string,
    category?: string,
    search?: string,
    recent: Pagination<Article>,
    funeral: Pagination<Article>,
    mourning: Pagination<Article>,
    inMemoriam: Pagination<Article>
  }>) {


  const [search, setSearch] = useState(initSearch)

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const route = relativeRoute('articles', {category: category, search: search})
      router.visit(route)
    }

    const categories = [{
      list: funeral,
      title: 'Uitvaart',
      category: 'uitvaart'
    },{
      list: mourning,
      title: 'Rouw',
      category: 'rouw'
    },{
      list: inMemoriam,
      title: 'In Memoriam',
      category: 'in-memoriam'
    }]
    return (
      <Page title="Artikelen" pageType={CommercialPageType.ArticleList} adUnit={'articles'} harvestId={6914}>
        <section className={'bg-beige'}>

          <div className="container md:flex justify-between">
            <h1>Verhalen</h1>
            <div className="md:flex gap-4">

              <form onSubmit={handleSubmit}>
                <Search
                  placeholder={'Zoeken...'}
                  value={search}
                  onChange={(input) => setSearch(input)}
                />
              </form>
            </div>
          </div>

        </section>

        <section className={'section-b'}>
          <div className={'container'}>
            <div className={'intro'}>
              <h2>Actueel</h2>
              <a href={"/verhalen/nieuws"} data-testid={'more-news'}>Alles over Actueel bekijken <i
                className="fa-solid fa-angle-right"></i></a>
            </div>
            <StickyContainer component={<Commercial type={CommercialType.HalfPageSkyscraper} top/>}>
              <TileList>
                {recent.items.map((article, index) => <Tile
                  key={index}
                  article={article}
                />)}
              </TileList>
            </StickyContainer>
            <div className={'actions'}>
              <a
                href={relativeRoute('articles', {category: 'nieuws'})}
                className={'btn'}
                data-testid={'bottom-more-news'}
              >Toon meer nieuws</a>
            </div>
          </div>
        </section>

        <AdvertisementSection />

        {categories.map(({list, title, category}) => <Fragment key={category}>

          <section className={'section-b'}>
            <div className={'container'}>
              <div className={'intro'}>
                <h2>{title}</h2>
                <a href={relativeRoute('articles', {category})} data-testid={`more-${category}`}>Alles over {title} bekijken <i
                  className="fa-solid fa-angle-right"></i></a>
              </div>
              <StickyContainer component={<Commercial type={CommercialType.HalfPageSkyscraper}/>}>
                <TileList>
                  {list.items.length === 0 && `Geen artikelen in category '${category}'`}
                  {list.items.map((article, index) => <Tile
                    key={index}
                    article={article}
                  />)}
                </TileList>
              </StickyContainer>
              {list.pages > 1 && <div className={'actions'}>
                <a
                    href={relativeRoute('articles', {category})}
                    className={'btn'}
                    data-testid={`bottom-more-${category}`}
                >Toon meer {title}</a>
              </div>
              }
            </div>
          </section>


          <AdvertisementSection />
        </Fragment>
    )}

      </Page>
    );
}
